// extracted by mini-css-extract-plugin
export default {"container":"components-return-title_container","svgContainer":"components-return-title_svgContainer"};